import { z } from "zod";
import { DateValidation } from "../shared/date-validation";

export const ServiceAppointmentItemSchema = z.object({
  Id: z.string().uuid(),
  ActivityTypeCode: z.number(),
  Category: z.string().optional(),
  Description: z.string().optional(),
  InstanceTypeCode: z.number().optional(),
  IsOnlineMeeting: z.boolean().optional(),
  Modified: DateValidation,
  ContactEmail: z.string().optional(),
  ContactPhone: z.string().optional(),
  InstallAppointment: z.boolean().optional(),
  Product: z.string().optional(),
  Service: z.string().optional(),
  IsPriceBookUpload: z.boolean().optional(),
  OnlineMeetingTypeCode: z.number().optional(),
  PriorityCode: z.number().optional(),
  ScheduledDurationMinutes: z.number().optional(),
  ScheduledEnd: DateValidation,
  ScheduledStart: DateValidation,
  ScheduleStartEst: DateValidation,
  StatusCode: z.number(),
  Subject: z.string().optional(),
  OwnerId: z.string().uuid().optional(),
  ServiceProductId: z.string().uuid().optional(),
  BusinessUnitId: z.string().uuid().optional(),
  BusinessUnitName: z.string().optional(),
  ServiceTypeId: z.string().uuid().optional(),
  ServiceTypeName: z.string().optional(),
  EngineerName: z.string().optional(),
  UserName: z.string().optional(),
  Duration: z.string().optional(),
});

export type ServiceAppointmentItemType = z.infer<
  typeof ServiceAppointmentItemSchema
>;

export const ServiceAppointmentsListSchema = z.array(
  ServiceAppointmentItemSchema,
);

export type AppointmentsListType = z.infer<
  typeof ServiceAppointmentsListSchema
>;

export const AppointmentStatus = {
  BUSY: 5,
  CANCELED: 4,
  COMPLETED_ACTIVE: 100000000,
  COMPLETED_INACTIVE: 3,
  FREE: 1,
  OUT_OF_OFFICE: 6,
  TENTATIVE: 2,
} as const;

export const AppointmentState = {
  OPEN: 0,
  COMPLETED: 1,
  CANCELED: 2,
  SCHEDULED: 3,
} as const;

export const OnlineMeetingType = {
  TEAMS: 1,
} as const;
